import Sms from './Index.vue';

export const routes = [
  {
    path: 'sms',
    name: 'talkvia_sms',
    meta: { permissions: ['administrator', 'campaign_manage'] },
    component: Sms,
  },
];
